

import React, { useEffect, useState } from 'react'
import { MenuPosition } from '../../../http/protocol';

import { useSelector } from 'react-redux';
import { AppState } from '../../../RootReducer';
import { getContainer } from '../../../ioc/IOCSetup';
import { changeLocaleDirectory } from '../../../i18n';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { Locale } from '../../../contenful/types';

export default function SideMenuLanguage(props: { position?: MenuPosition; isExpanded?: boolean }) {
    const [locales, setLocales] = useState<Array<Locale> | undefined>(undefined);
    const [defaultLocale, setDefaultLocale] = useState<Locale | undefined>(undefined);
    const [isRelative, setIsRelative] = useState(false);
    const isLoggedIn = useSelector((app: AppState) => app.user.user?.loggedIn);

    const handleClickLanguage = async (lng?: string) => {
        if (lng) {
            if (isLoggedIn) {
                await getContainer().getUserService()?.updateUserLocale(lng);
            }
            changeLocaleDirectory(lng);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsRelative(window.innerHeight > 800);
        };

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const fetchedLocales = getContainer().getSettingsService().getLocalesData();
        const fetchedDefaultLocale = getContainer().getSettingsService().getDefaultLocale();

        setLocales(fetchedLocales);
        setDefaultLocale(fetchedDefaultLocale);
    }, []);

    const getActiveLocale = (): Locale | undefined => {
        let activeLocale: Locale | undefined;
        if (locales) {
            activeLocale = locales.find((locale) => locale.code === getContainer().getSettingsService().getActiveLocale().code);
        }
        if (!activeLocale) {
            activeLocale = defaultLocale;
        }
        return activeLocale;
    };

    return (
        <div className={`language-wrapper-container ${!isRelative ? "active" : ""}`}>
            <DropdownButton
                id={`dropdown-btn`}
                className="dropdown-btn small"
                drop={"down"}
                variant="secondary"
                title={
                    <>
                        <i className="material-icons">language</i>

                        {getActiveLocale()?.name}
                    </>
                }
            >
                {locales &&
                    locales.map((locale, idx) => {
                        return (
                            <Dropdown.Item
                                onClick={() => {
                                    handleClickLanguage(locale.code);
                                }}
                                eventKey={idx}
                                key={locale.code}
                            >
                                {locale.name}
                            </Dropdown.Item>
                        );
                    })}
            </DropdownButton>
        </div>
    );
}
